import { DefaultResponseModel } from "@/types/http";
import http from "../utils/http-client";
import { UploadedFileModel } from "./book-creator";

export interface DirectoryModel {
  created_at: string;
  id?: string;
  name: string;
  updated_at: string;
}

export interface DirectoryResponse {
  files: Array<UploadedFileModel>;
  directories: Array<DirectoryModel>;
}
/**
 * 获取文件夹内的数据
 */
export const getDirectory = (directory_id?: string) => {
  return http.get<DirectoryResponse>({
    url: "/api/directory",
    params: {
      directory_id,
    },
  });
};

/**
 * 新建文件夹
 */
export const createDirectory = (dir_name: string, parent_id?: string) => {
  return http.post<DefaultResponseModel>({
    url: "/api/directory/create",
    data: {
      dir_name,
      parent_id,
    },
    unprocessed: true,
  });
};


/**
 * 重命名文件夹
 */
export const renameDirectory = (new_name: string, directory_id?: string) => {
    return http.post<DefaultResponseModel>({
      url: "/api/directory/rename",
      data: {
        new_name,
        directory_id,
      },
      unprocessed: true,
    });
  };
  
/**
 * 重命名文件夹
 */
export const deleteDirectory = (directory_id?: string) => {
    return http.post<DefaultResponseModel>({
      url: "/api/directory/delete",
      data: {
        directory_id,
      },
      unprocessed: true,
    });
  };